import base from "/opt/buildhome/repo/images/soundcloud.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");